import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClientsSection } from '../ui/testimonial-card';

const statsData = [
  { value: "10K+", label: "Happy Customers" },
  { value: "100%", label: "Pure Ceylon" },
];

const testimonialsData = [
  {
    name: "Sarah L.",
    title: "Verified Buyer",
    quote: "The best cinnamon I've ever tasted. It truly transforms my morning oatmeal and baking recipes.",
    avatarSrc: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop",
    rating: 5.0,
  },
  {
    name: "David K.",
    title: "Wellness Enthusiast",
    quote: "My skin feels amazing after using the coconut oil. Highly recommend their entire wellness line!",
    avatarSrc: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop",
    rating: 5.0,
  },
  {
    name: "Emily R.",
    title: "Tea Lover",
    quote: "A beautiful brand with exceptional products. The herbal teas are my absolute favorite for evening relaxation.",
    avatarSrc: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop",
    rating: 4.8,
  },
  {
    name: "Michael T.",
    title: "Chef",
    quote: "The quality of these spices is unmatched. They bring an authentic Sri Lankan flavor to my dishes.",
    avatarSrc: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop",
    rating: 5.0,
  }
];

const Testimonials = () => {
  const navigate = useNavigate();

  return (
    <ClientsSection
      title="CUSTOMER EXPERIENCES"
      description="Hear from our community who have embraced the authentic taste and wellness benefits of true Ceylon products."
      stats={statsData}
      testimonials={testimonialsData}
      primaryActionLabel="Shop Now"
      onPrimaryAction={() => navigate('/shop')}
      secondaryActionLabel="Our Story"
      onSecondaryAction={() => navigate('/aboutus')}
    />
  );
};

export default Testimonials;